import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { session } from 'services/session';
import analyticService from 'services/analytics';

import './search-bar.scss';
import {titleCase} from "../../common/utils";

class SearchBar extends Component {
	constructor(props) {
		super(props);
		this.searchQuery = new URLSearchParams(this.props.location.search).get('search_query');
		const tableNameMatches = this.props.location.pathname.match(/\/megatables\/(\w+)/);
		this.state = {
			searchTerm: this.searchQuery || '',
			previousSearch: null,
			currentTable: tableNameMatches ? tableNameMatches[1] : 'admin',
		};
		this.AnalyticService = analyticService;
	}

	componentDidUpdate() {
		this.updateSearchTerm();
		this.updateTableName();
	}

	updateTableName() {
		const tableName = this.props.location.pathname.match(/\/megatables\/(\w+)/);
		if (tableName && this.state.currentTable !== tableName[1]) {
			this.setState({
				currentTable: tableName[1],
			});
		}
	}

	handleFormChange(event) {
		this.setState({searchTerm: event.target.value});
	}

	editSearchFocused() {
		if (this.props.location.pathname.includes('/publisher/')) {
			const gaCategory = this.props.location.pathname.includes('dashboard') ?
				'Dashboard' : 'Mega Tables';
			this.AnalyticService.trackEvent(
				gaCategory, 'Click', `${this.formatTableName(this.state.currentTable)} Search Bar`
			);
		}
	}

	/*
	 * TODO: Move to a utils file for common use
	 * Formats table name from 'articles' to 'Article' for analytics purposes
	 */
	formatTableName(tableName) {
		return titleCase(tableName).slice(0, tableName.length - 1);
	}

	updateSearchTerm() {
		const tableName = this.props.location.pathname.match(/\/megatables\/(\w+)/);
		if (!tableName) return;

		const newParams = new URLSearchParams(this.props.location.search);
		const editQuery = newParams.get('search_query');
		if (editQuery !== this.state.previousSearch && tableName) {
			this.setState({
				previousSearch: this.state.searchTerm,
				searchTerm: editQuery,
				currentTable: tableName[1],
			});
		}
	}

	searchWithQuery(event) {
		event.preventDefault();
		const location = this.props.location.pathname;
		const searchTerm = this.state.searchTerm ?
			this.state.searchTerm.trim() : '';

		if (location === '/v2/admin/article-search') {
			this.props.history.push({
				search: `?search_query=${searchTerm}`,
			});
			return;
		}

		const pubId = location.match(/\/publisher\/(\d+)/)[1];

		if (location === `/v2/publisher/${pubId}/megatables/${this.state.currentTable}` &&
			this.state.searchTerm === this.state.previousSearch) {
			return;
		}

		const gaCategory = this.props.location.pathname.includes('dashboard') ?
			'Dashboard' : 'Mega Tables';
		this.AnalyticService.trackEvent(
			gaCategory, 'Execute',
			`${this.formatTableName(this.state.currentTable)} Search Bar ${searchTerm}`
		);

		this.props.history.push({
			pathname: `/v2/publisher/${pubId}/megatables/${this.state.currentTable}`,
			search: `?search_query=${searchTerm}`,
		});
	}

	displaySearch() {
		const editSearchPaths = [
			new RegExp(`/v2/admin/article-search`),
			new RegExp(`/v2/publisher/\\d+/megatables`),
		];
		return editSearchPaths.some((pattern) => {
			return this.props.location.pathname.match(pattern);
		});
	}

	render() {
		if (!this.displaySearch()) return null;

		const placeholder = {
			articles: `Search for a story's name or URL`,
			smartlinks: 'Search for a link',
			products: 'Search for a product',
			merchants: 'Search for a merchant',
		};

		return this.state.currentTable === 'articles' || session.isAdminView ? (
			<li className={
				`edit-search
				${this.props.navSidebarCollapsed ? 'move-left' : 'move-right'}
				${session.isAdminView ? 'feature-toggle' : ''}`
			}>
				<form onSubmit={this.searchWithQuery.bind(this)}>
					<div
						className="narrativ-icon search"
						onClick={this.searchWithQuery.bind(this)}>
					</div>
					<input
						type="text"
						placeholder={placeholder[this.state.currentTable]}
						value={this.state.searchTerm || ''}
						onClick={this.editSearchFocused.bind(this)}
						onChange={this.handleFormChange.bind(this)}
						className={`search ${this.state.currentTable}`}
					/>
				</form>
			</li>
		) : null;
	}
}

export default withRouter(SearchBar);
